import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchPeriods, fetchTeacherTimetable } from "./redux/myTimetableSlice";
import { fetchSessionsThunk } from "../../AcademicCalendar/redux/academicCalendarSlice";
import "./ShowTimeTable.css";
import Popup from "../../EventOrganiser/Popup";
import testSyllabus from "../Syllabus";
import userStore from "../../../zustand/userStore";
import { setStepIndex, setStepValid, stopTour } from "../../../redux/globalJoyrideSlice";
import { useNavigate } from "react-router-dom";

export default function ShowTimeTable() {
  const dispatch = useDispatch();

  const { teacherPeriods, periods, loading, error } = useSelector(
    (state) => state.myTimetable
  );
  // const { periods, loading, error } = useSelector((state) => state.myTimetable);
  // const teacherPeriods = testSyllabus;
  const sessions = useSelector((state) => state.academicCalendar.sessions);
  const [currentWeekStart, setCurrentWeekStart] = useState(null);
  const [sessionBounds, setSessionBounds] = useState({
    start: null,
    end: null,
  });
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [popupInfo, setPopupInfo] = useState(null);

  const userData = userStore((state) => state.user);
  const teacher_id = userData?.teacher_id;
  const navigate = useNavigate();

const { stepIndex, run } = useSelector(
  (state) => state.globalJoyride
);

  useEffect(() => {
    if (teacher_id) {
      dispatch(fetchPeriods());
      dispatch(fetchTeacherTimetable(teacher_id));
      dispatch(fetchSessionsThunk());
    }
  }, [dispatch, teacher_id]);

  useEffect(() => {
    if (!sessions?.length) return;

    const session = sessions[0];
    const today = moment();
    const sessionStart = moment(session.start_date);
    const sessionEnd = moment(session.end_date);

    let weekStart;
    if (today.isBefore(sessionStart)) {
      weekStart = sessionStart.clone().startOf("week").add(1, "day");
    } else if (today.isAfter(sessionEnd)) {
      weekStart = sessionEnd.clone().startOf("week").add(1, "day");
    } else {
      weekStart = today.clone().startOf("week").add(1, "day");
    }

    setCurrentWeekStart(weekStart);
    setSessionBounds({ start: sessionStart, end: sessionEnd });
  }, [sessions]);
 useEffect(() => {
  // Only start tour when class data is loaded
  if (teacherPeriods?.classes?.length > 0) {
    const timer = setTimeout(() => {
      dispatch(setStepIndex(1));
    }, 100);
    return () => clearTimeout(timer);
  }
}, [teacherPeriods.classes, dispatch]);

useEffect(() => {
  // index of timetable-table-step (last step)
  const LAST_STEP_INDEX = 5;

  if (run && stepIndex === LAST_STEP_INDEX) {
    // user clicked NEXT on timetable step
    dispatch(stopTour());
    navigate("/allSyllabus");
  }
}, [stepIndex, run, dispatch, navigate]);

  useEffect(() => {
    if (!selectedClassId) {
      setAvailableSections([]);
      return;
    }

    const selectedClass = teacherPeriods.classes.find(
      (cls) => cls.class_id === parseInt(selectedClassId)
    );

    if (selectedClass?.sections?.length > 0) {
      setAvailableSections(selectedClass.sections);
    } else {
      setAvailableSections([]);
      setSelectedSectionId("");
      alert("No section found for selected class");
    }
  }, [selectedClassId, teacherPeriods.classes]);

  // Week navigation
  const handlePrevWeek = () => {
    const newWeekStart = moment(currentWeekStart).subtract(7, "days");
    if (newWeekStart.isSameOrAfter(sessionBounds.start)) {
      setCurrentWeekStart(newWeekStart);
    }
  };

  const handleNextWeek = () => {
    const newWeekStart = moment(currentWeekStart).add(7, "days");
    if (newWeekStart.isSameOrBefore(sessionBounds.end)) {
      setCurrentWeekStart(newWeekStart);
    }
  };

  const isNavDisabled = (dir) => {
    if (!sessionBounds.start || !sessionBounds.end || !currentWeekStart)
      return true;
    const newDate = moment(currentWeekStart).add(
      dir === "next" ? 7 : -7,
      "days"
    );
    return dir === "next"
      ? newDate.isAfter(sessionBounds.end)
      : newDate.isBefore(sessionBounds.start);
  };

  // Handle custom date selection
  const handleDateChange = (e) => {
    const inputDate = moment(e.target.value);
    setSelectedDate(e.target.value);

    if (
      inputDate.isSameOrAfter(sessionBounds.start, "day") &&
      inputDate.isSameOrBefore(sessionBounds.end, "day")
    ) {
      setCurrentWeekStart(inputDate.clone().startOf("week").add(1, "day"));
      setDateError("");
    } else {
      setDateError("Selected date is outside the session period.");
    }
  };

  // Valid weekdays within session for display
  const getValidDays = () => {
    if (!sessionBounds.start || !sessionBounds.end || !currentWeekStart)
      return [];

    const start = moment.max(moment(currentWeekStart), sessionBounds.start);
    const end = moment.min(
      moment(currentWeekStart).add(6, "days"),
      sessionBounds.end
    );

    const validDays = [];
    let current = start.clone();
    while (current.isSameOrBefore(end)) {
      const weekday = current.format("dddd");
      if (
        [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ].includes(weekday)
      ) {
        validDays.push({ name: weekday, date: current.clone() });
      }
      current.add(1, "day");
    }
    return validDays;
  };

  // Cell content logic
  const getCellContent = (day, period_id) => {
    const data = teacherPeriods?.periods || [];
    const entry = data.find(
      (item) =>
        item.day === day &&
        item.period_id === period_id &&
        (!selectedSectionId || item.section_id === parseInt(selectedSectionId))
    );

    return entry
      ? {
          subject: entry.subject_name,
          section: entry.section_name,
          filled: true,
        }
      : { subject: "", section: "", filled: false };
  };

  const getPeriodStyle = (type, name) => {
    if (name.toLowerCase().includes("lunch")) return "#ffebee";
    if (type === "assembly") return "#e3f2fd";
    if (type === "break") return "#fff8e1";
    return "#e8f5e9";
  };

  const formatTime = (timeStr) => moment(timeStr, "HH:mm:ss").format("h:mm A");
  if (!userData?.teacher_id) {
    return (
      <Popup
        title="Access Restricted"
        height="300px"
        maxWidth="500px"
        onClose={() => window.history.back()}
        minHeight="200px"
      >
        <div className="text-center p-4">
          <h3 className="text-xl font-bold mb-3">
            ⚠️ Teacher Assignment Needed
          </h3>
          <p className="mb-4">
            You are not yet assigned as a teacher. Please contact the
            administrator to get a teacher ID before viewing your timetable.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </Popup>
    );
  }
  // Early return if session not yet loaded
  if (!currentWeekStart) return <p>Loading session details...</p>;

  // Render UI
  return (
    <div className="timetable-container px-5">
      {/* Filters */}
      <div className="filter-container">
        <label>
          Class:
          <select
          data-tour="select-class-step"
            className="form-select"
            value={selectedClassId}
            onChange={(e) => {
              setSelectedClassId(e.target.value);
              setSelectedSectionId("");
              dispatch(setStepIndex(2)); // move to section step
            }}
          >
            <option value="">Select Class</option>
            {teacherPeriods.classes?.map((cls) => (
              <option key={cls.class_id} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </label>

        <label style={{ marginLeft: "20px" }}>
          Section:
          <select
          data-tour="select-section-step"
            className="form-select"
            value={selectedSectionId}
            onChange={(e) =>{
              setSelectedSectionId(e.target.value)
              dispatch(setStepIndex(3))
            }
               }
            disabled={availableSections.length === 0}
          >
            <option value="">Select Section</option>
            {availableSections.map((sec) => (
              <option key={sec.section_id} value={sec.section_id}>
                {sec.section_name}
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* Week Navigation */}
      <div
        className="mt-2 d-flex align-items-center   mx-auto gap-3"
        style={{ width: "fit-content" }}
      >
        <button
          className="nav-button"
          onClick={handlePrevWeek}
          disabled={isNavDisabled("prev")}
        >
          ⬅️
        </button>
        <h2 className="timetable-title">
          Weekly Time Table: {currentWeekStart.format("DD MMM")} -{" "}
          {moment(currentWeekStart).add(5, "days").format("DD MMM")}
        </h2>
        <button
          className="nav-button"
          onClick={handleNextWeek}
          disabled={isNavDisabled("next")}
        >
          ➡️
        </button>
      </div>

      {/* Date Picker */}
      <div className="date-picker-container">
        <label>Select a Date: </label>
        <input
        data-tour="select-date-step"
       
          className="select-control"
          type="date"
          value={selectedDate}
          onChange={(e) => {
    handleDateChange(e);
dispatch(setStepValid(true))

  }}
          min={sessionBounds.start?.format("YYYY-MM-DD")}
          max={sessionBounds.end?.format("YYYY-MM-DD")}
        />
        {dateError && <p className="error-text">{dateError}</p>}
      </div>

      {/* Loading/Error Messages */}
      {loading && <p>Loading timetable...</p>}
      {error && <p className="error-text">{error}</p>}

      {/* Timetable Table */}
      {!loading && !error && periods.length > 0 && (
        
        <div className="table-wrapper"
        data-tour="timetable-table-step"
        >
          <table className="timetable-table">
            <thead>
              <tr>
                <th className="header-cell">Day & Date</th>
                {periods.map((period) => (
                  <th
                    key={period.period_id}
                    className="header-cell"
                    style={{
                      backgroundColor: getPeriodStyle(
                        period.period_type,
                        period.period_name
                      ),
                    }}
                  >
                    <div className="period-name">{period.period_name}</div>
                    <div className="period-time">
                      {formatTime(period.start_time)} -{" "}
                      {formatTime(period.end_time)}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {getValidDays().map(({ name, date }) => (
                <tr key={name}>
                  <td className="day-cell">
                    <div>{name}</div>
                    <div className="day-date">{date.format("DD MMM YYYY")}</div>
                  </td>
                  {periods.map((period) => {
                    const { subject, section, filled } = getCellContent(
                      name,
                      period.period_id
                    );
                    return (
                      <td
                        key={period.period_id}
                        className={`period-cell ${filled ? "filled" : "empty"}`}
                        onClick={() =>
                          setPopupInfo({
                            date: date.format("DD MMM YYYY"),
                            day: name,
                            period: period.period_name,
                          })
                        }
                      >
                        <div className="subject">{subject}</div>
                        <div className="section">{section}</div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          {popupInfo && (
            // <div className="popup-overlay" onClick={() => setPopupInfo(null)}>
            //   <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            //     <h3>📅 Period Info</h3>
            //     <p>
            //       <strong>Date:</strong> {popupInfo.date}
            //     </p>
            //     <p>
            //       <strong>Day:</strong> {popupInfo.day}
            //     </p>
            //     <p>
            //       <strong>Period:</strong> {popupInfo.period}
            //     </p>
            //     <button onClick={() => setPopupInfo(null)}>Close</button>
            //   </div>
            // </div>
            <Popup
              title="Period Details"
              height="500px"
              maxWidth="1000px"
              onClose={() => setPopupInfo(null)}
              minHeight="500px"
            >
              <div>
                <h3>📅 Period Info</h3>
                <p>
                  <strong>Date:</strong> {popupInfo.date}
                </p>
                <p>
                  <strong>Day:</strong> {popupInfo.day}
                </p>
                <p>
                  <strong>Period:</strong> {popupInfo.period}
                </p>
                <button onClick={() => setPopupInfo(null)}>Close</button>
              </div>
            </Popup>
          )}
        </div>
      )}
    </div>
  );
}
